<div id="clustered-column-chartdiv" style="width: 100%; height: 500px"></div>